// Footer.js

const Footer = () => {
    return (
        <footer className="flexing wrapper">
            <p>Created at <a href="https://junocollege.com/">Juno College</a></p>
        </footer>
    )
}

export default Footer;